// /**
//  * Created by hibo on 29/05/17.
//  */
// import React, {Component} from 'react';
// import {connect} from 'react-redux';
// import {Field, reduxForm} from 'redux-form';
// import {FormFieldHelpers as Form} from '../../../helpers';
// import * as registrationActions from '../../../actions/registration/registration';
//
// //todo - fire an event/email
// class RegistrationForm extends Component {
//
//     render() {
//
//         const {handleSubmit, postRegistrationForm, registration, pristine, submitting, reset} = this.props;
//         return (
//             <div>
//                 <h1 className="h1">Registration</h1>
//                 <form onSubmit={ handleSubmit(postRegistrationForm) }>
//                     <div>
//                         <Field
//                             name="first_name"
//                             label="First Name"
//                             placeholder="Write your first name here."
//                             component={ Form.textField }
//                             validate={
//                                 Form.validate( "first_name" )
//                             }
//                         />
//
//                     </div>
//
//                     <div>
//                         <Field
//                             name="last_name"
//                             label="Last Name"
//                             placeholder="Write your last name here."
//                             component={ Form.textField }
//                             validate={ Form.validate( "last_name" ) }
//                         />
//                     </div>
//
//                     <div>
//                         <Field
//                             name="email"
//                             label="Email"
//                             placeholder="Write your email here."
//                             component={ Form.textField }
//                             validate={ Form.validate( "email" ) }
//                             //also validate it is an email
//                         />
//                     </div>
//
//                     <div>
//                         <Field
//                             name="phone_number"
//                             label="Phone number"
//                             placeholder="Write your phone number here."
//                             component={ Form.textField }
//                             validate={ Form.validate( "phone_number" ) }
//                             // also validate it is a number and what type
//                         />
//                     </div>
//
//                     <div>
//                         <Field
//                             name="password"
//                             label="Password"
//                             placeholder="Write your password here."
//                             component={ Form.textField }
//                             validate={ Form.validate( "password" ) }
//                             // also needs password validation, star out
//                         />
//                     </div>
//
//                     <div>
//                         <Field
//                             name="password_confirmation"
//                             label="Password Confirmation"
//                             placeholder="Confirm your password here."
//                             component={ Form.textField }
//                             validate={ Form.validate( "first_name" ) }
//                             // also needs password and matching validation
//                             // star out
//                         />
//                     </div>
//
//                     <button type="submit" disabled={ pristine || submitting }>Save</button>
//                     <button type="button" onClick={ reset }>Clear values</button>
//                 </form>
//             </div>
//         )
//     }
// }
//
// RegistrationForm = reduxForm({form: 'registrationform'})(RegistrationForm);
//
// const mapStateToProps = (state) => {
//     return {
//         registration: state.registration.registration,
//     }
// };
//
// const mapDispatchToProps = (dispatch) => {
//     return {
//         postRegistrationForm: (registration) => dispatch(registrationActions.postRegistrationForm(registration)),
//
//     }
// };
//
// export default connect(mapStateToProps, mapDispatchToProps)(RegistrationForm);


// WEBPACK FOOTER //
// src/client/components/site/pages/Registration.js